import { render, staticRenderFns } from "./PreventFoolNotice.vue?vue&type=template&id=17e29abb&scoped=true"
import script from "./PreventFoolNotice.vue?vue&type=script&lang=js"
export * from "./PreventFoolNotice.vue?vue&type=script&lang=js"
import style0 from "./PreventFoolNotice.vue?vue&type=style&index=0&id=17e29abb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e29abb",
  null
  
)

export default component.exports